export const GLOBALIZATION_SYSTEM_ID = process.env.REACT_APP_GLOBALIZATION_SYSTEM_ID;

export const GLOBALIZATION_BASE_API_URL = process.env.REACT_APP_GLOBALIZATION_BASE_API_URL;

// GET - Retorna termos e traduções para uma tag
export const GLOBALIZATION_GET_TERMS_AND_TRANSLATIONS_BY_TAG_ENDPOINT = '/terms/translations/tags';
